import { isEmpty } from 'radash';
import { useFormContext } from 'react-hook-form';
import { useShallow } from 'zustand/react/shallow';

import { Input } from '@/components/core/Input';

import useFocusOnAttribute from '../hooks/useFocusOnAttribute';
import { useIsAttributeReadonly } from '../hooks/useIsAttributeReadonly';
import { useIsHiddenAttribute } from '../hooks/useIsHiddenAttribute';
import { usePlaceholder } from '../hooks/usePlaceholder';
import { useValidationsStore,Validation } from '../hooks/useValidationsStore';
import { Layout } from '../Layout/Layout';
import { EditorComponent } from '../types';

interface PasswordComponentProps extends EditorComponent {
    // Password specific props go here
}

const PasswordComponent = ({
    attribute,
    direction = 'horizontal',
    fieldPath = attribute.name,
    hidden = false,
    readonly = false,
    hideLabel = false,
    gridMode = false,
    beforeAttributeControl,
    handleUrlChange
}: PasswordComponentProps) => {

    const placeholder = usePlaceholder(attribute, readonly);

    const focusRef = useFocusOnAttribute<HTMLInputElement>(attribute);
    const validationErrors = useValidationsStore(useShallow(state => state.validationErrors[fieldPath] as Validation[]));
    const validationWarnings = useValidationsStore(useShallow(state => state.validationWarnings[fieldPath] as Validation[]));
    const hasErrors = !isEmpty(validationErrors);
    const hasWarnings = !isEmpty(validationWarnings);

    hidden = useIsHiddenAttribute(attribute, attribute.name, hidden);

    readonly = useIsAttributeReadonly(attribute, attribute.name, readonly);

    const { register, watch } = useFormContext();
    const currentValue = watch(fieldPath, '');

    if (hidden) {
        return null;
    }

    return (
        <Layout attribute={attribute} hideLabel={hideLabel} direction={direction} fieldPath={fieldPath} gridMode={gridMode} beforeAttributeControl={beforeAttributeControl} isClearable={false}>
            <div className="tw-flex tw-flex-row">
                <Input
                    id={fieldPath}
                    borderless={gridMode}
                    className={`${hasErrors ? 'error-input' : hasWarnings ? 'warning-input': ''}`}
                    placeholder={placeholder}
                    disabled={readonly}
                    type='password'
                    value={currentValue}
                    {...register(fieldPath)}
                    ref={focusRef}
                    onClick={handleUrlChange}
                />
            </div>
        </Layout>
    );
};

export { PasswordComponent };
